import React, {useCallback} from 'react'
import ListItem, {BaseProps} from './ListItem'
import {ColInfo, ColPhoto, ColStat} from '../Col'
import styles from '../../../../CSS/main.css'
import classNames from 'classnames'
import Button from '../../Button/Button'
import {formatDate} from '../../../utils/date'
import {User} from './CommentsItem'
import {formatNumber} from '../../../utils/number'
import {useNavigation} from '../../../utils/navigation'

type Props = {
  readonly user: Readonly<User>
  readonly onApprove: () => void
  readonly onBlock: () => void
  readonly onDelete: () => void
} & BaseProps

const UserItem: React.VFC<Props> = ({
  onSelected,
  selected,
  options,
  user,
  onApprove,
  onBlock,
}) => {
  const {goTo} = useNavigation()

  const navigateToUser = useCallback(() => {
    // goTo(Routes.EditUser, { id: user.id })
  }, [])

  const isPending = !user.blocked && !user.trusted

  return (
    <ListItem
      onClick={navigateToUser}
      onSelected={onSelected}
      selected={selected}
      options={options}>
      <ColPhoto>
        <div
          className={styles.Avatar}
          style={{backgroundImage: `url(${user.avatar})`}}
        />
      </ColPhoto>
      <ColInfo>
        <p className={classNames([styles.InfoBig, styles.Ellipsis])}>
          {user.displayName}
        </p>
        <p className={classNames([styles.InfoSmall, styles.Ellipsis])}>
          <b>Username: {user.name}</b> | Email: EMAIL NEEDED
          {/*
            BRIGHTEON-16979 (T34) — V7.2's acceptance criterion for this ticket is that a
            comment-only account "appears in the comments admin UI as comment-only".

            🔴 Read from the stored flag, never inferred from a missing channelId: a null channel
            also happens to an ordinary SSO user whose profile fetch degraded, and labelling that
            person an account class they are not is worse than showing nothing.

            Rendered with the classes this line already uses rather than a new badge class. This
            app's CSS is a fixed stylesheet with no utility system, so a className that does not
            exist in it is silently inert — the element simply renders unstyled and the label would
            look like a mistake.
          */}
          {user.commentOnly ? <b> | Comment-only account</b> : null}
        </p>

        <div className={styles.ButtonBlock}>
          <Button
            onClick={onApprove}
            additionalClassNames={[
              styles.ButtonCombo,
              styles.IconAdminApprove,
              ...(user.trusted ? [styles.IconAdminApproved] : []),
            ]}>
            Approve
          </Button>
          <Button
            onClick={onBlock}
            additionalClassNames={[
              styles.ButtonCombo, 
              styles.IconAdminBlock,
              ...(user.blocked ? [styles.IconAdminBlocked] : [])
            ]}>
            Ban
          </Button>
        </div>

      </ColInfo>
      <ColStat>{(isPending ? 'Pending' : user.blocked ? 'Disabled' : 'Enabled')}</ColStat>
    </ListItem>
  )
}

export default UserItem
